module.exports = __webpack_public_path__ + "img/testA2.ab094f03.webp";